/* Pluto cart drawer: plan under each item, renewal line that matches the
   plans in the cart, and subtotal plus discount lines above the total.
   Runs after the theme rebuilds the drawer (theme.miniCart.generateCart). */
(function () {
  if (window.__plutoCartUi) return;
  window.__plutoCartUi = true;

  function money(cents) {
    try { if (window.theme && theme.Currency && theme.moneyFormat) return theme.Currency.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function planName(item) {
    var a = item && item.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.name || '') : '';
  }
  function cadence(name) {
    var n = name.toLowerCase();
    if (/90[\s-]?day|quarter|3[\s-]?month/.test(n)) return 90;
    if (/30[\s-]?day|month/.test(n)) return 30;
    return 0;
  }
  function planLabel(item) {
    var name = planName(item); if (!name) return '';
    var c = cadence(name);
    var supply = name.replace(/\s*\([^)]*\)\s*/g, ' ').replace(/[.,]\s*$/, '').trim();
    if (c === 90) return supply + ', renews every 90 days';
    if (c === 30) return supply + ', renews monthly';
    return supply;
  }
  function renewSentence(items) {
    var seen = {};
    items.forEach(function (it) { var c = cadence(planName(it)); if (c) seen[c] = true; });
    var keys = Object.keys(seen);
    if (!keys.length) return '';
    if (keys.length > 1) return 'Each item renews on its own plan, pause or cancel anytime. ';
    return (keys[0] === '90' ? 'Renews every 90 days' : 'Renews monthly') + ', pause or cancel anytime. ';
  }

  function paint(cart) {
    document.querySelectorAll('.js-mini-cart').forEach(function (root) {
      root.querySelectorAll('.mini-cart-item').forEach(function (row, i) {
        var item = cart.items[i]; var meta = row.querySelector('.mini-cart-meta'); if (!meta) return;
        var label = item ? planLabel(item) : '';
        var tag = meta.querySelector('.pl-plan');
        if (!label) { if (tag) tag.remove(); return; }
        if (!tag) {
          tag = document.createElement('span'); tag.className = 'pl-plan';
          var title = meta.firstElementChild;
          if (title && title.nextSibling) meta.insertBefore(tag, title.nextSibling); else meta.appendChild(tag);
        }
        if (tag.textContent !== label) tag.textContent = label;
      });

      var taxes = root.querySelector('.mini-cart-taxes');
      if (taxes) {
        var text = 'All in: your clinician visit, the pharmacy and free shipping are included. ' + renewSentence(cart.items) + 'Texas residents only.';
        if (taxes.textContent.trim() !== text.trim()) taxes.textContent = text;
      }

      var total = root.querySelector('.mini-cart-total .bottom-total');
      if (total) {
        var box = root.querySelector('.pl-cart-lines');
        var lineDisc = 0; cart.items.forEach(function (it) { lineDisc += it.line_level_total_discount || 0; });
        var apps = cart.cart_level_discount_applications || [];
        if (!(cart.total_discount > 0)) { if (box) box.remove(); return; }
        if (!box) { box = document.createElement('div'); box.className = 'pl-cart-lines'; total.parentNode.insertBefore(box, total); }
        var html = '<div class="pl-cart-line"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>';
        if (lineDisc > 0) html += '<div class="pl-cart-line pl-cart-line--discount"><span>Item discounts</span><span>-' + money(lineDisc) + '</span></div>';
        apps.forEach(function (d) {
          if (d.total_allocated_amount > 0) html += '<div class="pl-cart-line pl-cart-line--discount"><span>' + esc(d.title) + '</span><span>-' + money(d.total_allocated_amount) + '</span></div>';
        });
        if (box.innerHTML !== html) box.innerHTML = html;
      }
    });
  }

  var timer = null, inflight = false, queued = false;
  function refresh() {
    if (inflight) { queued = true; return; }
    inflight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {})
      .then(function () { inflight = false; if (queued) { queued = false; refresh(); } });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 80); }

  function watch() {
    document.querySelectorAll('.js-mini-cart-content').forEach(function (el) {
      if (el.__plWatch) return; el.__plWatch = true;
      new MutationObserver(soon).observe(el, { childList: true });
    });
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.plutoCartUiRefresh = refresh;
})();
